export default "__VITE_ASSET__BtRLVrMT__"